import React from "react";
import { Navigate } from "react-router-dom";

const AuthmiddlewareRetrait = (props) => {
  if (!localStorage.getItem("tokenRetrait")) {
    return (
      <Navigate to={{ pathname: "/login-retrait", state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
   {props.children}
  </React.Fragment>);
};

export default AuthmiddlewareRetrait;
